import { FormControlLabel, FormGroup, Stack, Typography } from "@mui/material";
import type { FC, ReactElement } from "react";

interface Props {
  readonly availableTags: Record<string, string[]>;
  readonly renderControl: (category: string, value: string) => ReactElement;
}

/** Lays out the available tags as one labelled column per category. */
const TagCategoryColumns: FC<Props> = ({ availableTags, renderControl }) => (
  <Stack direction="row" spacing={2}>
    {Object.entries(availableTags).map(([category, values]) => (
      <Stack key={category} direction="column" spacing={1}>
        <Typography variant="subtitle2">{category}</Typography>
        <FormGroup>
          {values.map((value) => (
            <FormControlLabel key={value} control={renderControl(category, value)} label={value} />
          ))}
        </FormGroup>
      </Stack>
    ))}
  </Stack>
);

export default TagCategoryColumns;
